/**
 * 路由级 meta 更新（title / description / keywords / canonical / og）
 *
 * 工具站是 SPA，所有路由共用同一个 index.html。没有这段逻辑的话，
 * 每个工具页的标题都是「纯净未知 · 文档转换」，完全没有关键词区分度。
 *
 * 数据来源：src/data/tool-seo.js（与「页面底部说明区块」「构建期预渲染」共用同一份）
 */

import toolSeo from '../data/tool-seo.js';

const SITE = toolSeo.SEO_SITE.url;
const BRAND = toolSeo.SEO_SITE.brand;

function upsertMeta(attrName, attrValue, content) {
  let el = document.head.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * 按路由应用 meta。未知路由（如 /tasks）回落到默认标题。
 * @param {string} path 形如 '/pdf-tools'
 */
export function applyRouteMeta(path) {
  const seo = toolSeo.getToolSeo(path);
  // canonical 统一用 tool-seo.js 里的规范路径（带尾斜杠），
  // 与预渲染静态页、sitemap、nginx 目录跳转的方向保持一致，避免自我跳转。
  const canonicalPath = seo ? seo.path : path;
  const url = SITE + (canonicalPath === '/' ? '/' : canonicalPath);

  const title = seo ? seo.title : `${BRAND} · 文档转换`;
  const description = seo
    ? seo.description
    : '免费在线文档转换、PDF 工具箱、图片处理与 OCR 识别，网页版免安装免注册。';

  document.title = title;
  upsertMeta('name', 'description', description);
  upsertMeta('name', 'keywords', seo ? seo.keywords : '');
  upsertLink('canonical', url);

  upsertMeta('property', 'og:title', title);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:url', url);
}

/**
 * 加载百度统计（幂等：重复调用不会重复插入 script）。
 * 由 main.js 在启动时调用一次；SEO_SITE.tongjiId 为空时直接返回。
 */
export function initTongji() {
  const id = toolSeo.SEO_SITE.tongjiId;
  if (!id) return;
  if (document.getElementById('cx-hm-baidu')) return;

  window._hmt = window._hmt || [];
  const hm = document.createElement('script');
  hm.id = 'cx-hm-baidu';
  hm.async = true;
  hm.src = `https://hm.baidu.com/hm.js?${id}`;
  const first = document.getElementsByTagName('script')[0];
  if (first && first.parentNode) {
    first.parentNode.insertBefore(hm, first);
  } else {
    document.head.appendChild(hm);
  }
}

export default applyRouteMeta;
